//import Cookies
import Cookies from 'js-cookie';
//export class Multistepform
export default class Multistepform {
  constructor(el, config) {
    //el is form with multistep class
    this.el = el;
    this.config = config;
    this.steps = this.getSteps();
    console.log(this);
    this.initialize();
  }

  initialize() {
    this.insertButtons();
  }

  getSteps() {
    //gather steps
    return [...this.el.querySelectorAll('.step')];
  }

  hideStep(el) {
    //hides step
    el.classList.add('hidden');
  }

  showStep(el) {
    //shows step
    el.classList.remove('hidden');
  }

  validateFields(step) {
    //validates fields in current step
    let valid = true;
    [...step.querySelectorAll('.check')].forEach((field) => {
      console.log(field.value);
      if (field.value === '') {
        valid = false;
        field.classList.add('validate');
      } else {
        field.classList.remove('validate');
      }
    });
    return valid;
  }

  setCurrentStep(step) {
    //sets a cookie with current step
    Cookies.set('currentStep', step);
  }

  insertButtons() {
    this.steps.forEach((step, index) => {
      console.log(index + 1);
      console.log(this.steps.length);
      if (index + 1 !== this.steps.length) {
        step.insertAdjacentHTML(
          'beforeend',
          `<button class="next-step" id="step-${index + 1}-next" data-nextstep="${index + 2}">next</button>`
        );
        this.clickHandler(step);
      }
    });
  }

  clickHandler(step) {
    console.log(step);
    const buttons = [...step.querySelectorAll('.next-step')];
    buttons.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        if (this.validateFields(step)) {
          console.log(e.target.dataset.nextstep);
          this.steps.forEach((step) => {
            if (e.target.dataset.nextstep === step.dataset.step) {
              this.showStep(step);
            } else {
              this.hideStep(step);
            }
          });
        }
      });
    });
  }
}
